/**
 * Converte uma string no formato "YYYY-MM" para uma Date local
 * Evita problemas de timezone que ocorrem com new Date('YYYY-MM-01')
 */
export function parseYearMonthToDate(yearMonth: string): Date {
  const [year, month] = yearMonth.split('-').map(Number);
  return new Date(year, month - 1, 1); // month é 0-indexed
}

/**
 * Parseia uma string de data de forma segura, evitando bug de timezone.
 * Datas "YYYY-MM-DD" (sem horário) são interpretadas como local em vez de UTC.
 */
export function parseDateSafe(dateStr: string | Date | null | undefined): Date | null {
  if (!dateStr) return null;
  if (dateStr instanceof Date) return dateStr;
  // "YYYY-MM-DD" puro → local
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
    return new Date(dateStr + 'T00:00:00');
  }
  // "YYYY-MM-DD HH:mm:ss+00" ou ISO → extrair só a data, tratar como local
  const match = dateStr.match(/^(\d{4}-\d{2}-\d{2})/);
  if (match) {
    return new Date(match[1] + 'T00:00:00');
  }
  return new Date(dateStr);
}

/**
 * Retorna o início do dia em UTC para uma data no horário de Brasília (UTC-3).
 * Ex: "28/02/2026 00:00 Brasil" → "28/02/2026 03:00 UTC"
 */
export function startOfDayBrasilia(date: Date): Date {
  // Usa valores locais do browser (que já está em Brasília UTC-3) para construir UTC correto
  // Meia-noite de Brasília (UTC-3) = 03:00 UTC
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 3, 0, 0, 0));
}

/**
 * Retorna o fim do dia em UTC para uma data no horário de Brasília (UTC-3).
 * Ex: "28/02/2026 23:59 Brasil" → "01/03/2026 02:59 UTC"
 */
export function endOfDayBrasilia(date: Date): Date {
  // 23:59:59.999 de Brasília (UTC-3) = 02:59:59.999 UTC do dia seguinte
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() + 1, 2, 59, 59, 999));
}

/**
 * Converte uma data UTC (vinda do Supabase) para horário de Brasília (UTC-3).
 * Subtrai 3 horas da data UTC para exibir no fuso correto.
 */
export function toBrasilia(date: Date): Date {
  const brasiliaOffset = -3 * 60; // -3 horas em minutos
  const utcOffset = date.getTimezoneOffset(); // offset local em minutos
  const diff = brasiliaOffset + utcOffset; // diferença entre local e Brasília
  return new Date(date.getTime() + diff * 60 * 1000);
}
